import { ipfsApiClient } from '@/api/clients'

export interface IpfsUploadResponse {
  data?: {
    id?: string
    type?: string
    attributes?: {
      hash?: string
    }
  }
  id?: string
  attributes?: {
    hash?: string
  }
  hash?: string
}

export async function uploadIpfsFile(file: File): Promise<string> {
  const formData = new FormData()

  formData.append('image', file, file.name)

  const { data } = await ipfsApiClient.post<IpfsUploadResponse>(
    'integrations/ipfs-svc/v1/public/upload-file',
    formData,
  )

  const cid =
    data?.data?.attributes?.hash || data?.attributes?.hash || data?.hash

  if (!cid) {
    throw new Error('Failed to upload file to IPFS')
  }

  return cid
}

export async function uploadIpfsJson(metadata: unknown): Promise<string> {
  const payload = {
    data: {
      type: 'upload_json',
      attributes: {
        metadata,
      },
    },
  }
  const { data } = await ipfsApiClient.post<IpfsUploadResponse>(
    'integrations/ipfs-svc/v1/public/upload',
    payload,
    {
      headers: { 'Content-Type': 'application/vnd.api+json' },
    },
  )
  const cid =
    data?.data?.attributes?.hash || data?.attributes?.hash || data?.hash
  if (!cid) throw new Error('Failed to upload JSON to IPFS')
  return cid
}
